<achoo-iframe [source]="route"></achoo-iframe>


// WEBPACK FOOTER //
// ./src/app/main/admin/admin.component.html